module.exports = __webpack_public_path__ + "img/ren_2.fcd20c0c.webp";